export const messages = {
  wronggame: {
    title: "Das Spiel existiert nicht",
    message:
      "Ein solches Spiel gibt es nicht. Melden Sie sich im Trainer-Panel an und versuchen Sie es erneut.",
    event: "wronggame",
  },
  wrongcode: {
    title: "Gerätekonflikt",
    message:
      "Das Spiel wurde wahrscheinlich auf einem anderen Gerät gestartet. Wenn Sie es auf dieses Gerät übertragen möchten, melden Sie sich im Trainer-Panel an und nutzen Sie die entsprechende Option.",
    event: "wronggcode",
  },
  expired: {
    title: "Das Spiel ist vorbei",
    message:
      "Es ist wahrscheinlich keine Zeit mehr zu spielen. Melden Sie sich im Trainerbereich an und überprüfen Sie Ihre Spieleliste.",
    event: "wronggcode",
  },
  missingcredentials: {
    title: "Keine Spieldaten.",
    message:
      "Sie versuchen wahrscheinlich, das Spiel zu starten, indem Sie den Link auf ein anderes Gerät einfügen. Melden Sie sich im Trainerbereich an und starten Sie das Spiel.",
    event: "wronggcode",
  },
  diceTitle: "Wirf einen Würfel und wähle das Ergebnis",
  diceOr: "ODER",
};
export const de = {
  tutorial: {
    Vipers: {
      name: "Schlangennest",
      effect: "display",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 6,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du bewegst dich vorsichtig durch die Büsche. Du hörst ein leises Rascheln in den nahegelegenen Büschen, aber alles beruhigt sich, sobald du dich langsam in entfernst.",
      badDescription1:
        "Du gehst an den nahegelegenen Büschen vorbei und summst mit, um dir Mut zu machen. Plötzlich hörst Du ein rachsüchtiges Zischen! Bevor du ausweichen kannst, springt dir eine Natter an die Waden und beisst dich heftig.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Shrubbery: {
      name: "Dornige Büsche",
      effect: "display/toss",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: 1,
      badKarma3: 1,
      badKarma4: 1,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      badDescription1:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      badDescription2:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      badDescription3:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      badDescription4:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      badDescription5:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      badDescription6:
        "Entlang der Straße wachsen viele dornige Pflanzen, an denen man sich leicht schneiden kann. Es ist dir jedoch gelungen, Ärger zu vermeiden.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
  },
  game: {
    Village: {
      name: "Sumpfdorf",
      effect: "display",
      protection: "none",
      protectedKarma: 2,
      badKarma1: 2,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du kommst an einem Dorf vorbei, in dem seltsame Kreaturen leben. Sie haben die Angewohnheit, Fremde mit stinkendem Schlamm zu bewerfen. Sie wissen, was sie tun, denn es ist wirklich schwer, den Geruch abzuwaschen.",
      badDescription1:
        "Du kommst an einem Dorf vorbei, in dem seltsame Kreaturen leben. Sie haben die Angewohnheit, Fremde mit stinkendem Schlamm zu bewerfen. Sie wissen, was sie tun, denn es ist wirklich schwer, den Geruch abzuwaschen.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Swamps: {
      name: "Sumpf",
      effect: "display",
      protection: "breathing-spell",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du hast den Sumpf betreten. Die Überfahrt ist zwar beschwerlich, aber relativ ruhig – nur die Luft ist so dick, dass man sie schneiden kann.",
      badDescription1:
        "Du hast den Sumpf betreten. Obwohl die Überfahrt beschwerlich ist, ist es relativ ruhig – nur die beißenden Dämpfe reizen den Hals. Es scheint nichts zu passieren, aber Du beginnst seltsam zu husten.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Mountains: {
      name: "Berge des Wahnsinns",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 7,
      badKarma2: 17,
      badKarma3: 15,
      badKarma4: 18,
      badKarma5: 10,
      badKarma6: 19,
      worseKarma1: 7,
      worseKarma2: 7,
      worseKarma3: 17,
      worseKarma4: 17,
      worseKarma5: 18,
      worseKarma6: 15,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Dir wird schwindelig, aber du näherst dich gehorsam der Kante und springst. Um dich zu retten, müssen alle anderen damit aufhören, was sie gerade tun, und dir zu Hilfe eilen.",
      badDescription2:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Im letzten Moment erlangst du das Bewusstsein wieder, aber du hast den Eindruck, dass die Stimmen in deinem Kopf für immer bei dir bleiben werden.",
      badDescription3:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Im letzten Moment erlangst du das Bewusstsein wieder, aber du hast den Eindruck, dass die Stimmen in deinem Kopf für immer bei dir bleiben werden.",
      badDescription4:
        "Die Aussicht auf die Berge ist äußerst interessant. Das ist egal weil du beim Nachdenken und Bewundern hingefallen bist und dir viele blaue Flecken zugezogen hast.",
      badDescription5:
        "Die Aussicht auf die Berge ist äußerst interessant. Das ist egal weil du beim Nachdenken und Bewundern hingefallen bist und dir an einem hervorstehenden Stein die Wange aufgeschnitten hast.",
      badDescription6:
        "Berge sind Berge: Die Umgebung ist eintönig bis zum Wahnsinn. Man hat das Gefühl, schon mehrmals hier gewesen zu sein. Du drehst dich im Kreis und findest nicht den richtigen Weg.",
      worseDescription1:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Dir wird schwindelig, aber du näherst dich gehorsam der Kante und springst. Um dich zu retten, müssen alle anderen damit aufhören, was sie gerade tun, und dir zu Hilfe eilen.",
      worseDescription2:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Dir wird schwindelig, aber du näherst dich gehorsam der Kante und springst. Um dich zu retten, müssen alle anderen damit aufhören, was sie gerade tun, und dir zu Hilfe eilen.",
      worseDescription3:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Im letzten Moment erlangst du das Bewusstsein wieder, aber du hast den Eindruck, dass die Stimmen in deinem Kopf für immer bei dir bleiben werden.",
      worseDescription4:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Im letzten Moment erlangst du das Bewusstsein wieder, aber du hast den Eindruck, dass die Stimmen in deinem Kopf für immer bei dir bleiben werden.",
      worseDescription5:
        "Die Aussicht auf die Berge ist äußerst interessant. Das ist egal weil du beim Nachdenken und Bewundern hingefallen bist und dir viele blaue Flecken zugezogen hast.",
      worseDescription6:
        "Die Aura des Wahnsinns lässt dich Stimmen hören, die dir sagen, du sollst in den Abgrund springen. Im letzten Moment erlangst du das Bewusstsein wieder, aber du hast den Eindruck, dass die Stimmen in deinem Kopf für immer bei dir bleiben werden.",
    },
    Footbridge: {
      name: "Steg",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 8,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du fällst ins Wasser, weil der Steg instabil ist. Darunter lebt ein bösartiger Troll. Er mochte dich, also hat er dir nicht wehgetan und du bist sicher auf die andere Seite gekommen.",
      badDescription1:
        "Du fällst ins Wasser, weil der Steg instabil ist. Darunter lebt ein bösartiger Troll. Er mochte dich nicht, also schlug er dich mit einem Knüppel – du hast es kaum geschafft, auf die andere Seite zu kommen und dort kriechst du langsam aus dem Wasser.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Avalanche: {
      name: "Steinlawinen",
      effect: "display/toss",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 9,
      badKarma2: 9,
      badKarma3: 9,
      badKarma4: 9,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Auf die Straße, auf der du gehst, fallen Steine, aber du vermeidest es, von ihnen getroffen zu werden.",
      badDescription1:
        "Steine ​​fallen auf die Straße, auf der du gehst, und einer davon trifft dich am Kopf.“ Dir ist nicht nur schwindelig, sondern es entwickelt sich auch eine riesige Beule.",
      badDescription2:
        "Steine ​​fallen auf die Straße, auf der du gehst, und einer davon trifft dich am Kopf.“ Dir ist nicht nur schwindelig, sondern es entwickelt sich auch eine riesige Beule.",
      badDescription3:
        "Steine ​​fallen auf die Straße, auf der du gehst, und einer davon trifft dich am Kopf.“ Dir ist nicht nur schwindelig, sondern es entwickelt sich auch eine riesige Beule.",
      badDescription4:
        "Steine ​​fallen auf die Straße, auf der du gehst, und einer davon trifft dich am Kopf.“ Dir ist nicht nur schwindelig, sondern es entwickelt sich auch eine riesige Beule.",
      badDescription5:
        "Auf die Straße, auf der du gehst, fallen Steine, aber du vermeidest es, von ihnen getroffen zu werden.",
      badDescription6:
        "Auf die Straße, auf der du gehst, fallen Steine, aber du vermeidest es, von ihnen getroffen zu werden.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Generator: {
      name: "Magiegenerator",
      effect: "generator",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 5,
      badKarma2: 15,
      badKarma3: 20,
      badKarma4: 10,
      badKarma5: 21,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zauberfunken springen fröhlich zwischen den Polen. Du magst das Ganze sogar – schließlich hat man selten die Gelegenheit, etwas so Buntes zu sehen.",
      badDescription1:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zwischen den Polen funkeln Stromstöße und magische Funken fliegen. Einer von ihnen trifft dich und du versuchst erfolglos, wieder zu Atem zu kommen. Du würgst aber nach ein paar Sekunden vergeht das komische Gefühl. Ich denke, es gibt keinen Grund zur Sorge.",
      badDescription2:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zwischen den Polen funkeln Stromstöße und magische Funken fliegen. Einer von ihnen trifft dich und plötzlich weißt du nicht mehr, wer oder wo du bist. Die Erinnerung lässt nach, aber nach ein paar Sekunden verschwindet der Eindruck. Ich denke, es gibt keinen Grund zur Sorge.",
      badDescription3:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zwischen den Polen funkeln Stromstöße und magische Funken fliegen. Einer von ihnen schlägt dich und verbrennt dir die Augenbrauen. Sie werden nachwachsen, ich denke also, dass es keinen Grund zur Sorge gibt.",
      badDescription4:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zwischen den Polen funkeln Stromstöße und magische Funken fliegen. Einer von ihnen schlägt dich und verbrennt dir die Hand. Es wird heilen, ich denke also, dass es keinen Grund zur Sorge gibt.",
      badDescription5:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zwischen den Polen funkeln Stromstöße und magische Funken fliegen. Einer von ihnen schlägt dich und stößt dich zurück. Du bist gestürzt und es tut ein bisschen weh, aber ich denke, es gibt keinen Grund zur Sorge.",
      badDescription6:
        "Du gehst durch ein Gebiet voller ungewöhnlicher Konstruktionen und  Strukturen. Sie gehören wahrscheinlich Zauberern – jeder weiß, dass sie so seltsame Dinge bauen. Zwischen den Polen funkeln Stromstöße und magische Funken fliegen. Einer von ihnen verfehlt dich nur knapp.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Glade: {
      name: "Jagdlichtung",
      effect: "display",
      protection: "breastplate",
      protectedKarma: 1,
      badKarma1: 10,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du kommst an einer Lichtung vorbei, auf der Jäger jagen. Sie winken dir aus der Ferne fröhlich zu.",
      badDescription1:
        "Du kommst an einer Lichtung vorbei, auf der Jäger jagen, und ein Fuchs rennt gerade an dir vorbei. Du hörst ein Pfeifen und spürst einen Stich in deinem Gesäß – Du wurdest von einem Pfeil gestreift, der für einen Fuchs bestimmt war. Zum Glück ist es nur eine oberflächliche Wunde.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Ruins: {
      name: "Düstere Ruinen",
      effect: "display",
      protection: "none",
      protectedKarma: 3,
      badKarma1: 3,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du fährst zwischen Gebäuden hindurch und suchst nach einem kürzeren Weg zu deinem Ziel. Du weichst vorsichtig dem einstürzenden Turm aus – als plötzlich, aus dem Nichts, ein zerlumpter alter Mann auf dich zuspringt und dich bis in die fünfte Generation verflucht! Die Mauer der Beleidigungen kann man nicht durchbrechen. Peinlich rennst du von diesem Ort weg. Du bist noch lange nach dieser schockierenden Begegnung erschüttert.",
      badDescription1:
        "Du fährst zwischen Gebäuden hindurch und suchst nach einem kürzeren Weg zu deinem Ziel. Du weichst vorsichtig dem einstürzenden Turm aus – als plötzlich, aus dem Nichts, ein zerlumpter alter Mann auf dich zuspringt und dich bis in die fünfte Generation verflucht! Die Mauer der Beleidigungen kann man nicht durchbrechen. Peinlich rennst du von diesem Ort weg. Du bist noch lange nach dieser schockierenden Begegnung erschüttert.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Forest: {
      name: "Düsterwald",
      effect: "display",
      protection: "none",
      protectedKarma: 1,
      badKarma1: 1,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du fährst durch einen Wald, der aussieht, als könnte dir jeden Moment etwas Schreckliches entgegenspringen. Zum Glück siehst du bereits eine Lücke zwischen den Bäumen, noch ein paar Schritte und du bist in Sicherheit.",
      badDescription1:
        "Du fährst durch einen Wald, der aussieht, als könnte dir jeden Moment etwas Schreckliches entgegenspringen. Zum Glück siehst du bereits eine Lücke zwischen den Bäumen, noch ein paar Schritte und du bist in Sicherheit.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Crossing: {
      name: "Flussüberquerung",
      effect: "toss/toss",
      protection: "breathing-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 11,
      badKarma2: 11,
      badKarma3: 22,
      badKarma4: 22,
      badKarma5: 6,
      badKarma6: 5,
      worseKarma1: 11,
      worseKarma2: 11,
      worseKarma3: 11,
      worseKarma4: 11,
      worseKarma5: 22,
      worseKarma6: 6,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Du versuchst den letzten Schluck Luft einzufangen, aber über dir ist nur Wasser. Du erstickst und ertrinkst, und deine mit Wasser gefluteten Lungen verbrennen dich von innen. Jemand am Ufer ruft, dass du Hilfe brauchst. Sie haben dich gerettet, aber dein Körper funktioniert nicht mehr so ​​wie früher. Von nun an bewegst du dich etwas langsamer, du brauchst mehr Zeit für alles.",
      badDescription2:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Du versuchst den letzten Schluck Luft einzufangen, aber über dir ist nur Wasser. Du erstickst und ertrinkst, und deine mit Wasser gefluteten Lungen verbrennen dich von innen. Jemand am Ufer ruft, dass du Hilfe brauchst. Sie haben dich gerettet, aber dein Körper funktioniert nicht mehr so ​​wie früher. Von nun an bewegst du dich etwas langsamer, du brauchst mehr Zeit für alles.",
      badDescription3:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Ihn zu überqueren ist selbst für einen Helden wie dich eine Herausforderung. Erstickend am Wasser schwimmst du mit letzter Kraft zum Ufer. Du hast das Gefühl, dem Tod nahe gewesen zu sein und wirst nie wieder so sorglos sein wie früher.",
      badDescription4:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Ihn zu überqueren ist selbst für einen Helden wie dich eine Herausforderung. Erstickend am Wasser schwimmst du mit letzter Kraft zum Ufer. Du hast das Gefühl, dem Tod nahe gewesen zu sein und wirst nie wieder so sorglos sein wie früher.",
      badDescription5:
        "Der Fluss sieht zwar ruhig aus, ist aber sehr tückisch. Unzählige Male verschluckst du dich am Wasser, aber du erreichst die andere Seite. Es dauert lange, bis du wieder zu Atem kommst, und jetzt atmest du leicht keuchend. Du dachtest, es wäre einfacher.",
      badDescription6:
        "Der Fluss sieht zwar ruhig aus, ist aber sehr tückisch. Unzählige Male verschluckst du dich am Wasser, aber du erreichst die andere Seite. Es dauert lange, bis du wieder zu Atem kommst, und jetzt atmest du leicht keuchend. Du dachtest, es wäre einfacher.",
      worseDescription1:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Du versuchst den letzten Schluck Luft einzufangen, aber über dir ist nur Wasser. Du erstickst und ertrinkst, und deine mit Wasser gefluteten Lungen verbrennen dich von innen. Jemand am Ufer ruft, dass du Hilfe brauchst. Sie haben dich gerettet, aber dein Körper funktioniert nicht mehr so ​​wie früher. Von nun an bewegst du dich etwas langsamer, du brauchst mehr Zeit für alles.",
      worseDescription2:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Du versuchst den letzten Schluck Luft einzufangen, aber über dir ist nur Wasser. Du erstickst und ertrinkst, und deine mit Wasser gefluteten Lungen verbrennen dich von innen. Jemand am Ufer ruft, dass du Hilfe brauchst. Sie haben dich gerettet, aber dein Körper funktioniert nicht mehr so ​​wie früher. Von nun an bewegst du dich etwas langsamer, du brauchst mehr Zeit für alles.",
      worseDescription3:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Du versuchst den letzten Schluck Luft einzufangen, aber über dir ist nur Wasser. Du erstickst und ertrinkst, und deine mit Wasser gefluteten Lungen verbrennen dich von innen. Jemand am Ufer ruft, dass du Hilfe brauchst. Sie haben dich gerettet, aber dein Körper funktioniert nicht mehr so ​​wie früher. Von nun an bewegst du dich etwas langsamer, du brauchst mehr Zeit für alles.",
      worseDescription4:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Du versuchst den letzten Schluck Luft einzufangen, aber über dir ist nur Wasser. Du erstickst und ertrinkst, und deine mit Wasser gefluteten Lungen verbrennen dich von innen. Jemand am Ufer ruft, dass du Hilfe brauchst. Sie haben dich gerettet, aber dein Körper funktioniert nicht mehr so ​​wie früher. Von nun an bewegst du dich etwas langsamer, du brauchst mehr Zeit für alles.",
      worseDescription5:
        "Obwohl der Fluss ruhig aussieht, ist er sehr tückisch. Ihn zu überqueren ist selbst für einen Helden wie dich eine Herausforderung. Erstickend am Wasser schwimmst du mit letzter Kraft zum Ufer. Du hast das Gefühl, dem Tod nahe gewesen zu sein und wirst nie wieder so sorglos sein wie früher.",
      worseDescription6:
        "Der Fluss sieht zwar ruhig aus, ist aber sehr tückisch. Unzählige Male verschluckst du dich am Wasser, aber du erreichst die andere Seite. Es dauert lange, bis du wieder zu Atem kommst, und jetzt atmest du leicht keuchend. Du dachtest, es wäre einfacher.",
    },
    Dragon: {
      name: "Drachen",
      effect: "display",
      protection: "antiflame-spell",
      protectedKarma: 4,
      badKarma1: 12,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Du kommst an einer Drachenhöhle vorbei und weckst ihren Besitzer. Der Drache kriecht aus der Höhle und spuckt Feuer in alle Richtungen. ",
      badDescription1:
        "Du kommst an einer Drachenhöhle vorbei und weckst ihren Besitzer. Der Drache kriecht aus der Höhle und spuckt Feuer in alle Richtungen. ",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Appiary: {
      name: "Alter Bienenstock ",
      effect: "toss/toss",
      protection: "careful",
      protectedKarma: "nie dotyczy",
      badKarma1: 13,
      badKarma2: 2,
      badKarma3: 2,
      badKarma4: 2,
      badKarma5: 20,
      badKarma6: 20,
      worseKarma1: 13,
      worseKarma2: 13,
      worseKarma3: 13,
      worseKarma4: 2,
      worseKarma5: 2,
      worseKarma6: 2,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Du hast die mutierten giftigen Bienen wütend gemacht. Du warst am nächsten, also hat es dich am härtesten getroffen. Du siehst wirklich schlimm aus, wenn du geschwollen bist, außerdem sind die Bienen aus ihren Bienenstöcken geflogen und stechen jeden im Land. Um nicht zu sterben, muss von nun an jeder jeden Morgen ein zeitaufwändiges Gegenmittel vorbereiten.",
      badDescription2:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      badDescription3:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      badDescription4:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      badDescription5:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      badDescription6:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      worseDescription1:
        "Du hast die mutierten giftigen Bienen wütend gemacht. Du warst am nächsten, also hat es dich am härtesten getroffen. Du siehst wirklich schlimm aus, wenn du geschwollen bist, außerdem sind die Bienen aus ihren Bienenstöcken geflogen und stechen jeden im Land. Um nicht zu sterben, muss von nun an jeder jeden Morgen ein zeitaufwändiges Gegenmittel vorbereiten.",
      worseDescription2:
        "Du hast die mutierten giftigen Bienen wütend gemacht. Du warst am nächsten, also hat es dich am härtesten getroffen. Du siehst wirklich schlimm aus, wenn du geschwollen bist, außerdem sind die Bienen aus ihren Bienenstöcken geflogen und stechen jeden im Land. Um nicht zu sterben, muss von nun an jeder jeden Morgen ein zeitaufwändiges Gegenmittel vorbereiten.",
      worseDescription3:
        "Du hast die mutierten giftigen Bienen wütend gemacht. Du warst am nächsten, also hat es dich am härtesten getroffen. Du siehst wirklich schlimm aus, wenn du geschwollen bist, außerdem sind die Bienen aus ihren Bienenstöcken geflogen und stechen jeden im Land. Um nicht zu sterben, muss von nun an jeder jeden Morgen ein zeitaufwändiges Gegenmittel vorbereiten.",
      worseDescription4:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      worseDescription5:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
      worseDescription6:
        "Du hast die Bienen verärgert. Sie fliegen aus dem Bienenstock und stechen dich am ganzen Kopf. Du siehst wirklich schrecklich aus, wenn du geschwollen bist.",
    },
    Slippery: {
      name: "Rutschig",
      effect: "display/toss",
      protection: "careful",
      protectedKarma: 1,
      badKarma1: 14,
      badKarma2: 23,
      badKarma3: 23,
      badKarma4: 23,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Die Straßenverhältnisse sind wirklich schlecht, aber zum Glück bist du einem Ausrutschen aus dem Weg gegangen.",
      badDescription1:
        "Die Straßenverhältnisse sind wirklich ungünstig und du bist leider ausgerutscht. Es ist nichts Schlimmes passiert, du hast nur den Rest deines Zuges verschwendet, um dich auf zu rappeln. Außerdem hinkst du eine Zeit lang ein wenig.",
      badDescription2:
        "Die Straßenverhältnisse sind wirklich ungünstig und du bist leider ausgerutscht.“ Es ist nichts Ernstes passiert, aber du hinkst für einen Moment leicht. Du kannst es dem Arzt zeigen ODER die Zähne zusammenbeißen und weitermachen – schließlich ist es nur ein Bluterguss",
      badDescription3:
        "Die Straßenverhältnisse sind wirklich ungünstig und du bist leider ausgerutscht.“ Es ist nichts Ernstes passiert, aber du hinkst für einen Moment leicht. Du kannst es dem Arzt zeigen ODER die Zähne zusammenbeißen und weitermachen – schließlich ist es nur ein Bluterguss",
      badDescription4:
        "Die Straßenverhältnisse sind wirklich ungünstig und du bist leider ausgerutscht.“ Es ist nichts Ernstes passiert, aber du hinkst für einen Moment leicht. Du kannst es dem Arzt zeigen ODER die Zähne zusammenbeißen und weitermachen – schließlich ist es nur ein Bluterguss",
      badDescription5:
        "Die Straßenverhältnisse sind wirklich schlecht, aber zum Glück bist du einem Ausrutschen aus dem Weg gegangen.",
      badDescription6:
        "Die Straßenverhältnisse sind wirklich schlecht, aber zum Glück bist du einem Ausrutschen aus dem Weg gegangen.",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Wilderness: {
      name: "Magischer Ort",
      effect: "display",
      protection: "helmet",
      protectedKarma: 1,
      badKarma1: 15,
      badKarma2: "nie dotyczy",
      badKarma3: "nie dotyczy",
      badKarma4: "nie dotyczy",
      badKarma5: "nie dotyczy",
      badKarma6: "nie dotyczy",
      worseKarma1: "nie dotyczy",
      worseKarma2: "nie dotyczy",
      worseKarma3: "nie dotyczy",
      worseKarma4: "nie dotyczy",
      worseKarma5: "nie dotyczy",
      worseKarma6: "nie dotyczy",
      protectedDescription:
        "Offenbar tanzen Meerjungfrauen in der Gegend und verführen die Passanten mit ihrem Gesang. Es könnte sogar interessant sein, aber du hörst keinen Gesang. Enttäuscht gehst du weiter.",
      badDescription1:
        "Als du durch die Wildnis gehst, hörst du fröhliche und verführerische Gesänge. Noch nie ist jemand an ein bisschen Musik gestorben. Du gehst weiter und stellst fest, dass dir die Melodie in Erinnerung geblieben ist und du nicht aufhören kannst, sie zu summen.",
      badDescription2: "nie dotyczy",
      badDescription3: "nie dotyczy",
      badDescription4: "nie dotyczy",
      badDescription5: "nie dotyczy",
      badDescription6: "nie dotyczy",
      worseDescription1: "nie dotyczy",
      worseDescription2: "nie dotyczy",
      worseDescription3: "nie dotyczy",
      worseDescription4: "nie dotyczy",
      worseDescription5: "nie dotyczy",
      worseDescription6: "nie dotyczy",
    },
    Volcano: {
      name: "Vulkan",
      effect: "toss/toss",
      protection: "antiflame-spell",
      protectedKarma: "nie dotyczy",
      badKarma1: 16,
      badKarma2: 16,
      badKarma3: 10,
      badKarma4: 10,
      badKarma5: 1,
      badKarma6: 1,
      worseKarma1: 24,
      worseKarma2: 24,
      worseKarma3: 16,
      worseKarma4: 16,
      worseKarma5: 10,
      worseKarma6: 10,
      protectedDescription: "nie dotyczy",
      badDescription1:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du hast dich gerettet, aber dabei deine Hände verletzt, und um das Ganze noch schlimmer zu machen, hat die strömende Lava Löcher in dein Gesicht gebrannt.",
      badDescription2:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du hast dich gerettet, aber dabei deine Hände verletzt, und um das Ganze noch schlimmer zu machen, hat die strömende Lava Löcher in dein Gesicht gebrannt.",
      badDescription3:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du bist rausgekommen, hast dir dabei aber die Hände verletzt.",
      badDescription4:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du bist rausgekommen, hast dir dabei aber die Hände verletzt.",
      badDescription5:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg, aber du behältst das Gleichgewicht.",
      badDescription6:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg, aber du behältst das Gleichgewicht.",
      worseDescription1:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du hast dich gerettet, aber dabei deine Hände verletzt, und um das Ganze noch schlimmer zu machen, hat die strömende Lava Löcher in dein Gesicht gebrannt.",
      worseDescription2:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du hast dich gerettet, aber dabei deine Hände verletzt, und um das Ganze noch schlimmer zu machen, hat die strömende Lava Löcher in dein Gesicht gebrannt.",
      worseDescription3:
        "ŚDer Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du hast dich gerettet, aber dabei deine Hände verletzt, und um das Ganze noch schlimmer zu machen, hat die strömende Lava Löcher in dein Gesicht gebrannt.",
      worseDescription4:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du hast dich gerettet, aber dabei deine Hände verletzt, und um das Ganze noch schlimmer zu machen, hat die strömende Lava Löcher in dein Gesicht gebrannt.",
      worseDescription5:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du bist rausgekommen, hast dir dabei aber die Hände verletzt.",
      worseDescription6:
        "Der Weg verläuft am Rand des Kraters entlang. Als du daran entlang gehst, rutscht dir der Boden unter den Füßen weg. Um nicht in die Lava zu fallen, greifst du an die scharfen Kanten des Felsbrockens. Du bist rausgekommen, hast dir dabei aber die Hände verletzt.",
    },
  },
};
